import { Component } from '@angular/core';
import { SuperClass } from '../../../../superclass/SuperClass';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { CookieService } from 'ngx-cookie-service';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { ClientsService } from '../../../../services/clients/clients.service';
import { HttpClient } from '@angular/common/http';
import { WsService } from '../../../../services/websocket/WsService';
import { Country } from '../../vocabularies/countries/countries.model';
import { Globals } from '../../../../globals/Globals';
import { RouterConst } from '../../../../globals/RoutersConst';

@Component({
  selector: 'app-image-uploader',
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.css'],
})
export class ImageUploaderComponent extends SuperClass {
  countries = [];
  selectedCountry: Country;

  logoImage = './../../../../../assets/img/placeholders/logo_placeholder-300x167.png?id=' +
  'randomParam';
  mainImage = '?id=' + 'randomParam';
  facebookIconImage = '?id=' + 'randomParam';
  twitterIconImage = '?id=' + 'randomParam';
  nextIconImage = '?id=' + 'randomParam';

  currImageTag;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Captive Portal' },
      {
        label: 'Dynamic Images',
        routerLink: [{ outlets: { sub: [RouterConst.IMAGE_UPLOADER] } }],
      },
    ]);
  }

  toggleImages() {
    const clientId = this.cookiesService.get(Globals.COOKIES_CLIENT_ID);
    this.logoImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=LOGO&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.mainImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=LOGIN_IMAGE&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.facebookIconImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=CIRCLE_COLOR_FACEBOOK&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.twitterIconImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=CIRCLE_COLOR_TWITTER&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.nextIconImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=GREY_NAV_ARROW_MD&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
  }

  imageEdit(nextIconImage: string) {
    this.currImageTag = nextIconImage;
    document.getElementById('image_loader_btn').click();
  }

  onChangeImage(e) {
    this.http_uploadImage(
      this.selectedCountry.name,
      this.currImageTag,
      e,
      (data: any) => {
        this.toggleImages();
      },
    );
  }

  chooseCountry(e) {
    this.toggleImages();
  }

  getWebSocketIdentifier(): string {
    return '';
  }

  reloadData(): void {
    this.http_getImagesCountries((data: any) => {
      this.countries = data.payload;
      this.selectedCountry = this.countries[0];
      this.toggleImages();
    });
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/image-uploader/image-uploader.component.ts